export default (ms) => new Promise(r => setTimeout(r, ms))
